<script setup lang="ts">
import {useConfig} from '@/composables/config'
import FooterBlock from './FooterBlock.vue'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()
const config  = useConfig()

const props = defineProps<{
  title?: boolean|string
  card?: boolean
  skeleton?: string
}>()

let titleFinal = ''

if (typeof props.title === 'string') {
  titleFinal = props.title
}

if (typeof props.title === 'boolean' && props.title) {
  titleFinal = t('footer.location')
} else {
  titleFinal = ''
}
</script>

<template>
  <FooterBlock
      :card="card"
      class="footer-block--location"
      :title="titleFinal"
  >

    <slot v-if="$slots.default" />

    <template v-else>
      <VSkeletonLoader
          max-width="280px" class="mx-auto"
          :type="skeleton ? skeleton : 'list-item-two-line'"
      />
    </template>

  </FooterBlock>
</template>

<style scoped lang="scss">
.footer-block--location {

}
</style>